class FAQ {
  constructor(container) {
    this.container = container;

    this.summary = this.container.querySelector('summary');
    this.inner = this.container.querySelector('.c-faq__inner');

    if (this.container.open) {
      this.container.classList.add('is-open');
      this.setHeight();
    }

    this.summary.addEventListener('click', this.onClick);
    window.addEventListener('orientationchange', this.onOrientationChange);
  }

  onClick = ev => {
    ev.preventDefault();
    if (this.container.open) {
      // close
      this.inner.addEventListener(
        'transitionend',
        () => {
          this.container.open = false;
          this.inner.style.height = '';
        },
        {
          passive: true,
          once: true,
        },
      );
      this.container.classList.remove('is-open');
      this.inner.style.height = '0';
    } else {
      // open
      this.container.open = true;
      this.container.classList.add('is-open');
      window.requestAnimationFrame(() => {
        this.setHeight();

        this.inner.style.transitionDuration = '0ms';
        this.inner.style.height = '0';
        window.requestAnimationFrame(() => {
          this.inner.style.transitionDuration = '';
          this.inner.style.height = '';
        });
      });
    }
  };

  setHeight() {
    if (
      this.inner.style.getPropertyValue('--content-height') &&
      this.inner.style.getPropertyValue('--content-height') !== 'auto'
    ) {
      return;
    }

    this.inner.style.setProperty(
      '--content-height',
      `${this.inner.getBoundingClientRect().height}px`,
    );
  }

  onOrientationChange = () => {
    this.inner.style.setProperty('--content-height', 'auto');
    if (this.container.open) {
      window.requestAnimationFrame(() => {
        this.setHeight();
      });
    }
  };
}

export default () => {
  Array.from(document.querySelectorAll('.c-faq__details')).forEach(
    container => new FAQ(container),
  );
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/goodie-wp-chisel/src/scripts/modules/faq.js